// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  airId: __t.u64().primaryKey().name("air_id"),
  warId: __t.u64().name("war_id"),
  worldId: __t.u64().name("world_id"),
  side: __t.string(),
  versonaId: __t.u64().name("versona_id"),
  kind: __t.string(),
  chassisKey: __t.string().name("chassis_key"),
  hp: __t.i32(),
  state: __t.string(),
  anchorX: __t.f32().name("anchor_x"),
  anchorZ: __t.f32().name("anchor_z"),
  escortRef: __t.u64().name("escort_ref"),
  crashX: __t.f32().name("crash_x"),
  crashZ: __t.f32().name("crash_z"),
  downedBy: __t.identity().name("downed_by"),
  updatedAt: __t.timestamp().name("updated_at"),
});
